import * as ActionTypes from "./actionTypes";

export function loadPosts(appKey) {
	return { type: ActionTypes.LOAD_POSTS, appKey };
}

export function loadPostsSuccess(posts) {
	return { type: ActionTypes.LOAD_POSTS_SUCCESS, posts };
}

export function loadPostsFail(errorMessage) {
	return { type: ActionTypes.LOAD_POSTS_FAIL, errorMessage };
}

export function selectPost(post) {
	return { type: ActionTypes.SELECT_POST, post };
}

export function selectPostSuccess(post) {
	return { type: ActionTypes.SELECT_POST_SUCCESS, post };
}

export function resetCurrentPost() {
	return { type: ActionTypes.RESET_CURRENT_POST };
}

export function selectPostFailure(errorMessage) {
	return { type: ActionTypes.SELECT_POST_FAILURE, errorMessage };
}
